import { useEffect, useContext } from 'react'

import { RegionContext } from '../context/RegionContext'

export const useRegion = (regionId, elementRef, priority = 0) => {
  const { updateRegion, removeRegion } = useContext(RegionContext)

  useEffect(() => {
    if (!elementRef.current) return

    // Helper to calculate and send normalized percentages
    const reportPosition = () => {
      if (!elementRef.current) return
      
      const rect = elementRef.current.getBoundingClientRect()
      
      // Divide pixels by window size to get 0.0 - 1.0 range
      updateRegion(regionId, {
        top: Number((rect.top / window.innerHeight).toFixed(4)),
        bottom: Number((rect.bottom / window.innerHeight).toFixed(4)),
        left: Number((rect.left / window.innerWidth).toFixed(4)),
        right: Number((rect.right / window.innerWidth).toFixed(4)),
        priority: priority
      })
    }

    // 1. Observer: Watches for element size changes
    const observer = new ResizeObserver(() => {
      reportPosition()
    })

    // 2. Start Observing
    observer.observe(elementRef.current)
    
    // 3. Window Listener: Watches for browser resize 
    window.addEventListener('resize', reportPosition)
    window.addEventListener('scroll', reportPosition) // Handle scroll shifts

    // Initial report
    reportPosition()

    // 4. Cleanup
    return () => {
      observer.disconnect()
      window.removeEventListener('resize', reportPosition)
      window.removeEventListener('scroll', reportPosition)
      removeRegion(regionId)
    }
  }, [regionId, elementRef, updateRegion, removeRegion, priority])
}